import querystring from 'querystring'
import Url from 'url'
/**
 * 获取一个 url 的所有参数组成的对象
 * @param {string} url 需要处理的url
 * @return {Object} 返回一个包含所有参数的 map
 */
export function getParams(url = window.location.href) {
	var query = Url.parse(url).query
	return querystring.parse(query)
}